import { useState, useEffect } from 'react';
import { supabaseGetter } from '~/api/supabase-getter';
import { useOrgParams } from '~/common/use-org-params';

/**
 * Hook to fetch active farm climate
 * @returns {Object} Farm climate record, loading state, and error
 */
export const useFarmClimate = () => {
  const { farmId } = useOrgParams()
  const [climate, setClimate] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchData() {
      if (!farmId) {
        setClimate(null)
        setLoading(false)
        setError(null)
        return
      }

      setLoading(true);
      setError(null);

      try {
        const { data: climateData, error: climateError } =
          await supabaseGetter.climates.getByOrganization(farmId);

        if (climateError) throw climateError;

        setClimate(climateData || null);
      } catch (err) {
        console.error('Error fetching farm climate data:', err);
        setError(err.message);
        setClimate([]);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, [farmId]);

  return {
    climate,
    loading,
    error,
    invalidate: () => {
      supabaseGetter.climates.invalidate();
    }
  };
}
